// extracted by mini-css-extract-plugin
export default {"newProjectPopover":"popover_newProjectPopover__PfhRy","searchPopover":"popover_searchPopover__-bPl8","mealPriceSettingsPopover":"popover_mealPriceSettingsPopover__m7Kcg"};